package com.patronat.top.core.di

import com.russhwolf.settings.Settings
import org.koin.core.module.Module
import org.koin.dsl.module

actual val platformModule: Module = module {
    single<Settings> {
        com.russhwolf.settings.StorageSettings()
    }
}